<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :data="model"
                   :title="$t(`Create New Department`)"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <translatable-input-widget :hint="false" :model="model" :fields="model.getTranslatableFieldsArray()"
                                 :errors="errors" @onInputChange="onNameChange"/>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="key"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="branches_uuids" multiple :items="branches && branches.rows ? branches.rows : []" display-field="${item.name}" type="select2"/>
        </div>
        <div class="col-md-12">
          <user-select-input-widget :model="model" attribute="specialists_uuids" multiple/>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-sm-12">
          <file-uploader :show-preview="false" @onItemsAdd="onImageChange" @onItemRemove="onItemRemove"
                         :with-tooltip="false"
                         :items-prop="files" :text="$t('Drag your image here')" :button-text="$t('Select Image')"
                         :hint-text="false" :multiple="false" :uploading-progress="uploadingProgress"
                         :uploading-progress-value="uploadingProgressValue" :accept="fileUploaderAccept"
                         ref="fileUploader"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import DepartmentModel from "./Department.model";
  import {createNamespacedHelpers} from "vuex";
  import {Formatter} from "../../../core/services/formatter.service";
  import TranslatableInputWidget from "../../../core/widgets/TranslatableInputWidget";
  import i18nHelper from "@/core/services/i18n.service";
  import FileUploader from "@/core/components/file-uploader/FileUploader";
  import BranchSelectInputWidget from "../../../core/widgets/BranchSelectInputWidget.vue";
  import UserSelectInputWidget from "../../../core/widgets/UserSelectInputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('setup/department');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');
  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');

  export default {
    name: "DepartmentModal",
    components: {UserSelectInputWidget, TranslatableInputWidget, InputWidget, ArtisioModal, FileUploader},
    data() {
      return {
        loading: false,
        // This indicates that modal should show confirmation dialog when something is changed inside, and we are trying
        // to close the modal
        showConfirmation: true,
        model: new DepartmentModel(),
        files: [],
        uploadingProgressValue: 0,
        uploadingProgress: false,
      }
    },
    computed: {
      ...mapState(['modal']),
      ...mapStateGlobal(['departmentThumbnailSettings']),
      ...mapStateBranch(['branches']),
      fileUploaderAccept() {
        return [{formats: this.departmentThumbnailSettings.formats, size: this.departmentThumbnailSettings.max_size}]
      },
    },
    methods: {
      ...mapActions(['hideModal', 'createDepartment']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.files = []
        this.model = new DepartmentModel();
        this.hideModal();
      },
      async onSubmit() {
        this.loading = true;
        let formData = new FormData();
        formData.append('uuid', this.model.uuid);
        formData.append('name', JSON.stringify(this.model.name));
        formData.append('key', this.model.key);
        this.model.branches_uuids.forEach((uuid, index) => formData.append(`branches_uuids`, uuid))
        this.model.specialists_uuids.forEach((uuid, index) => formData.append(`specialists_uuids`, uuid))
        if (this.files[0]) {
          formData.append('thumbnail_image', this.files[0].file);
        }
        this.onUploadProgress = true;
        let response = await this.createDepartment({
          formData, onUploadProgress: (progressEvent) => {
            this.uploadingProgressValue = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
          }
        });
        this.uploadProgress = false;
        this.uploadingProgressValue = 0;
        this.loading = false;
        if (response.success) {
          this.$toast('success', this.$t('Department was successfully added'));

          this.showConfirmation = false;
          this.onHidden();
        } else if (response.body.name) {
          this.model.setErrors('name_en', response.body.name);
        } else if (response.body.non_field_errors) {
          this.$errorDialog(response.body.non_field_errors[0])
        } else if (response.body[0] && response.body[0].file) {
          this.$errorDialog(response.body[0].file[0]);
        } else {
          this.model.setMultipleErrors(response.body);
        }
      },
      async onImageChange() {
        if (this.files.length > 1) {
          this.$errorDialog(this.$i18n.t('Only single file is allowed'), this.$i18n.t('Department Image'));
          await this.onItemRemove();
        }
      },
      async onItemRemove() {
        this.files = [];
        this.$refs.fileUploader.clearInput();
      },
      onNameChange(val, key) {
        if (key === i18nHelper.getMasterLanguage().key) {
          this.model.key = Formatter.toSlug(val);
        }
      }
    }
  }
</script>

<style scoped>

</style>
